import Request from '@/lib/request';

const Api = {};

export default Api;

// 登录（支持手机号、微信、QQ登录）
Api.login = (data, autoErrorTips = true) => Request({
  url: 'v1/cp/login',
  method: 'post',
  data,
  autoErrorTips,
});

// 获取用户信息（检查登录态）
Api.profile = (data, autoErrorTips = true) => Request({
  url: 'v3/user/profile',
  method: 'post',
  data,
  autoErrorTips,
});
